var FormFieldDropdown = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

  this.$label = this.options.$el.find("label");
  this.$select = this.options.$el.find("select");
  this.$inputContainer = this.options.$el.find(".input");
  this.$ghostLabel = $("<span class='ghost-label'></span>");
  this.$downArrow = $("<img src='/built/icons/arrow-down.svg' class='arrow-down' />");

  this.$inputContainer.append(this.$ghostLabel);
  this.$inputContainer.append(this.$downArrow);

};

FormFieldDropdown.prototype.init = function(){

  var self = this;

  // when the dropdown is updated
  this.$select.on("change", function(){
    var text = self.$select.find("option:selected").text();
    self.updateValue(text);
  });

  this.$select.trigger("change");

};

/**
 * Updating the value of the field
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */
FormFieldDropdown.prototype.updateValue = function(value){

  if(value.length){

    this.options.$el.addClass("is-active");
    this.$ghostLabel.text(value);

  }else{

    this.options.$el.removeClass("is-active");
    this.$ghostLabel.text(this.$label.text());

  }

}

export default  FormFieldDropdown;
